import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Field, FieldConfig} from 'app/demat/common/components/form/models';
import {UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'app-form-render-date',
  templateUrl: './form-render-date.component.html',
  styleUrls: ['./form-render-date.component.scss']
})
export class FormRenderDateComponent implements OnInit, OnChanges {
  @Input() formGroup: UntypedFormGroup;
  @Input() item: Field;
  fieldConfig: FieldConfig;
  blockFormName: String;


  constructor() {
  }

  ngOnInit() {
    this.blockFormName = `block-${this.item.block}`;
  }

  dateFilter = (d: Date | null): boolean => this._dateFilter(d, this.fieldConfig?.options);

  public fieldControl(blockId, fieldId) {
    return this.formGroup.get(`block-${blockId}`).get(`${fieldId}`);
  }

  getErrorMessage(blockId, fieldId) {
    const field = this.fieldControl(blockId, fieldId);
    if (field.errors?.matDatepickerMin) {
      return 'La date est antérieur à la date du jour.';
    }
    if (field.errors?.matDatepickerParse) {
      return 'La date n\'est pas valide.';
    }
    if (field.errors?.matDatepickerFilter) {
      return 'La date est une journée fermée.';
    }
    if (field.errors?.required) {
      return 'Le champ est obligatoire';
    }
  }

  /**
   * The getDay() method retourne la date de la semaine de la date d : 0 à 6
   * Sunday = 0, Monday = 1, ...:
   * @param {Date} d
   * @param options
   * @private
   */
  private _dateFilter(d: Date, options) {
    if (d) {
      // Voir common/components/form/form-builder/form-control/date-input/date-input-dialog.component.ts
      // Pour les valeurs par défaut
      const dayOpen = [
        options?.sunday ?? true,
        options?.monday ?? true,
        options?.tuesday ?? true,
        options?.wednesday ?? true,
        options?.thursday ?? true,
        options?.friday ?? true,
        options?.saturday ?? true
      ];
      const day = d.getDay();
      return dayOpen[day];
    }
    return true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.item?.currentValue) {
      this.fieldConfig = changes?.item?.currentValue.options_obj;
    }
  }
}
